// A body-level bar that appears when the connection to the server is lost and
// auto-dismisses when it recovers (plan item 4). Mirrors readyBanner.ts: a fixed
// element appended to <body>, so it survives SPA screen swaps. Driven entirely
// by connState.ts — this module is just the view.

import { connState, onConnState, type ConnState } from "../connState.ts";
import { t } from "../i18n/index.ts";

let bar: HTMLElement | undefined;

/** Resource admission is distinct from server reachability and needs an
 * explicit retry, so multiple devices cannot continually replace each other. */
export function showSocketNotice(message: string, retry: () => void): () => void {
  document.getElementById("socket-notice")?.remove();
  const notice = document.createElement("div");
  notice.id = "socket-notice"; notice.setAttribute("role", "status");
  const text = document.createElement("span"); text.textContent = message;
  const button = document.createElement("button"); button.className = "btn ghost"; button.type = "button"; button.textContent = "Retry live updates";
  button.onclick = () => { notice.remove(); retry(); };
  notice.append(text, button); document.body.append(notice);
  return () => notice.remove();
}

/** Wire the status bar once, at app start. */
export function initServerStatus(): void {
  onConnState(render);
  render(connState());
}

function render(state: ConnState): void {
  // Only a sustained loss (`down`) surfaces; a transient `degraded` blip stays
  // quiet to avoid flapping the bar on every brief reconnect.
  if (state === "down") show();
  else hide();
}

function show(): void {
  if (bar) return;
  bar = document.createElement("div");
  bar.id = "server-status";
  bar.setAttribute("role", "status");
  bar.setAttribute("aria-live", "polite");
  const dot = document.createElement("span");
  dot.className = "ss-dot";
  const text = document.createElement("span");
  text.textContent = t("serverStatus.lost");
  bar.append(dot, text);
  document.body.append(bar);
}

function hide(): void {
  bar?.remove();
  bar = undefined;
}
